import React, {
  ReactElement,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import Box from "@mui/material/Box";

export const SetGuideCell = ({props}: { props: any }): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);
  const [visibleFindGuide, setVisibleFindGuide] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (
      divWidth['element'] > divWidth['cell'] ||
      (props.value?.status_lamp && props.value?.icon)
    ) {
      setTooltip(true);
    }
  });

  const tagsArray = props.value || [];

  const hasFindGuide = props?.row?.find_guide ? tagsArray.some((tag: any) => tag?.id === 0) : true;

  const tags = hasFindGuide
    ? tagsArray
    : [...tagsArray, {
      id: 0,
      name: 'Find a guide',
      guide_status: {
        color: {
          color: '#af1011',
        },
      },
    }];
  const tagsWithOutFindGuide = [...tagsArray];

  const colors = tagsWithOutFindGuide.length >= 2
    ? tags
      .filter((item: any) => item.id !== 1524)
      .map((item: any) => item?.guide_status?.color?.color ?? '')
    : tags
      .map((item: any) => item?.guide_status?.color?.color ?? '');

  let background = "";

  if (colors.length === 1) {
    background = colors[0];
  } else if (colors.length > 1) {

    const step = 100 / colors.length;

    const gradient = colors
      .map((color: any, index: any) => {
        return `${color ? color : 'transparent'} ${index * step}% ${index * step + step}%`;
      })
      .join(", ");
    background = `linear-gradient(180deg, ${gradient})`;
  }

  useLayoutEffect(() => {
    if (divRef.current) {
      const divElement: any = divRef.current;
      const parentElement = divElement.parentNode;

      if (parentElement) {
        parentElement.style.background = background;
      }

    }
  }, [props.value]);

  return (
    <Box
      ref={divRef}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={tags.map(function (item: any, index: number) {
              const name = item?.phone
                ? `${item?.name ? item?.name : '-'} (${item.phone})`
                : item?.name
                  ? item?.name
                  : '-';

              return <div key={index}>{name}</div>;
            })}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <div>
              {tags.map((item: any) => {

                if (tagsWithOutFindGuide.length >= 2 && item?.id === 1524) {
                  return <></>;
                }

                const name = item?.phone
                  ? `${item?.name ? item?.name : '-'} (${item.phone})`
                  : item?.name
                    ? item?.name
                    : '-';

                return <div style={{color: item?.id === 0 ? '#fefefe' : ''}}>{name}</div>
              })}
            </div>
          </Tooltip>
        </>
      ) : (
        <>
          {tags.map((item: any) => {

            if (tagsWithOutFindGuide.length >= 2 && item?.id === 1524) {
              return <></>;
            }

            const name = item?.phone
              ? `${item?.name ? item?.name : '-'} (${item.phone})`
              : item?.name
                ? item?.name
                : '-';
            return <div style={{color: item?.id === 0 ? '#fefefe' : ''}}>{name}</div>
          })}
        </>
      )}
    </Box>
  );
};
